export default {
  title01: "מזג אוויר נוכחי",
  title02: " שעות",
  title03: "הצג תחזית מזג אוויר ל-10 ימים",
  title04: "AQI",
  title05: "ראה את כל המידע",
  title06: "זריחה ושקיעה",
  title07: "מופע הירח",
  title08: "הירח המלא הבא",
  title09: "הירח החדש הבא",
  title10: "ום",
  title11: "לילה",
  title12: "זריחה",
  title13: "שקיעה",
  title14: "זריחת ירח",
  title15: "שקיעה של ירח",
  title16: "מקור",
  title17: "התחל",
  title18: "סוף",
  title19: "השתמש במיקום נוכחי",
  title20: "חפש בעיר",
  title21: "מרגיש כמו",
  title22: "מרגיש כמו צל",
  title23: "עכשיו",
  title24: "היום",
  title25: "יום ראשון",
  title26: "יום שני",
  title27: "יום שלישי",
  title28: "יום רביעי",
  title29: "יום חמישי",
  title30: "יום שישי",
  title31: "יום שבת",
  title32: "טוען...",
  title33: "עכשיו",
  title34: "שָׁעוֹנִי",
  title35: "יומי",
  title36: "שמש וירח",
  title37: "איכות האוויר",
  title38: "יצירת קשר: xlf550402@gmail.com",
  title39: "הסכם פרטיות",
  title40: "זכויות יוצרים © comfortweather.com 2020 - 2026. כל הזכויות שמורות.",
  title41: "נתונים מסופקים על ידי",
  title42: "היי",
  title43: "לו",
  title44: "קבל",
  title45: "תודה על השימוש ב-ComfortWeather! כדי להגן טוב יותר על הזכויות והאינטרסים המשפטיים שלך, אנא קרא את ה ",
  title46: "מדיניות פרטיות",
  title47: " בזהירות לפני השימוש.",
  title48: "",
  title49: "יצירת קשר: xyjph123@gmail.com",
  title50: "זכויות יוצרים © 24hweather.com 2020 - 2026. כל הזכויות שמורות.",
  title51: "תודה על השימוש ב-ComfortWeather! כדי להגן טוב יותר על הזכויות והאינטרסים המשפטיים שלך, אנא קרא את ה ",
  title52: "המיקום שלך השתנה. האם ברצונך לעדכן אותו?",
  title53: "אשר",
  title54: "בטל",
  title55: "חזרה",
  title56: "חדשות",
  title57: "עדכון מזג אוויר...",
  title58: "מזג אוויר מעודכן",
  title59: "הצג הכל",
  title60: "זכויות יוצרים © mobi321.com 2020 - 2026. כל הזכויות שמורות.",
  title61: "אתמול",
  title62: "מחר",
  title63: "הצג תחזית מזג אוויר ל-15 ימים",
  title64: "פרטי היום",
  title65: "Rahu Kaal",
  title66: "מדדי אורח חיים",
  title67: "מדדי אורח חיים",
  title68: "未来7天Rahu Kala时间表",
  title69: "至",
  title70: "至",
  title71: "空气质量指数",

  title102: "קשה לייבוש",
  title103: "ייבוש איטי",
  title104: "מתייבש היטב",
  title105: "ייבוש מהיר",
  title106: "ייבוש מהיר מאוד",

  title107: "לא מתאים",
  title108: "חוויה סבירה",
  title109: "טוב לפעילויות מים",
  title110: "מתאים מאוד",
  title111: "תנאים מושלמים",

  title112: "תנאים תומכים בבריאות",
  title113: "תנאים ניטרליים",
  title114: "סיכון מעט גבוה יותר",
  title115: "סיכון גבוה",
  title116: "סיכון גבוה מאוד",

  title117: "לא מתאים",
  title118: "מתאים במידה מסוימת",
  title119: "טוב לפעילות חוץ",
  title120: "מתאים מאוד",
  title121: "תנאים מצוינים",

  title122: "תנאים יבשים מאוד",
  title123: "סביר שיהיה יבש",
  title124: "יובש קל",
  title125: "לא סביר שיהיה יבש",
  title126: "לא סביר כלל שיהיה יבש",

  title127: "לא מומלץ",
  title128: "סביר",
  title129: "יום טוב",
  title130: "תנאים טובים מאוד",
  title131: "תנאים אידיאליים",
};
